// Paket Perlengkapan Umrah — Add-on selectable saat booking
// Data statis (bisa dipindah ke backend nanti kalau perlu di-admin-kan)

export const EQUIPMENT_PACKAGES = [
  {
    id: "eq-platinum",
    tier: 1,
    name_id: "Perlengkapan Lengkap — Platinum / Titanium",
    name_en: "Complete Equipment — Platinum / Titanium",
    price_idr: 2_000_000,
    note_id: "Platinum / Titanium",
    note_en: "Platinum / Titanium",
    accent: "amber",
    items_id: [
      "Koper Bagasi Premium 24\"",
      "Koper Kabin Premium 20\"",
      "Exclusive Moslem Wear by Fadkhera",
      "Kain Ihram + Sabuk",
      "Jilbab dan Mukena (untuk akhwat)",
      "Syal Sajadah",
      "Tas Paspor, Tas Laundry, & Tas Sandal",
      "Buku Panduan Umrah Praktis",
      "Buku 125 Doa Bekal Muslim",
      "Gantungan doa & dzikir",
      "Gantungan Kunci",
      "ID Card Siskopatuh",
      "Tag koper dan stiker koper",
      "Manasik dan Handling",
    ],
    items_en: [
      "Premium 24\" Check-in Luggage",
      "Premium 20\" Cabin Luggage",
      "Exclusive Moslem Wear by Fadkhera",
      "Ihram Cloth + Belt",
      "Hijab & Mukena (for women)",
      "Prayer Mat Scarf",
      "Passport, Laundry & Sandal Bags",
      "Practical Umrah Guide Book",
      "Book of 125 Daily Muslim Prayers",
      "Prayer & Dhikr Pendant",
      "Keychain",
      "Siskopatuh ID Card",
      "Luggage Tag & Sticker",
      "Manasik & Handling",
    ],
  },
  {
    id: "eq-bronze-silver-gold",
    tier: 2,
    name_id: "Perlengkapan Lengkap — Bronze / Silver / Gold (Start Jakarta)",
    name_en: "Complete Equipment — Bronze / Silver / Gold (Jakarta Start)",
    price_idr: 1_750_000,
    note_id: "Bronze / Silver / Gold — Start Jakarta",
    note_en: "Bronze / Silver / Gold — Jakarta departure",
    accent: "slate",
    items_id: [
      "Koper Bagasi 24 inch",
      "Koper Kabin 20 inch",
      "Exclusive Moslem Wear by ANTUM",
      "Kain ihram + sabuk",
      "Jilbab & Mukena (untuk akhwat)",
      "Syal Sajadah",
      "Tas Paspor, Tas Laundry, & Tas Sandal",
      "Buku Panduan Umrah Praktis",
      "Buku 125 Doa Bekal Muslim",
      "Gantungan doa & dzikir",
      "Gantungan Kunci",
      "ID Card Siskopatuh",
      "Tag koper dan stiker koper",
      "Manasik dan Handling",
    ],
    items_en: [
      "24-inch Check-in Luggage",
      "20-inch Cabin Luggage",
      "Exclusive Moslem Wear by ANTUM",
      "Ihram Cloth + Belt",
      "Hijab & Mukena (for women)",
      "Prayer Mat Scarf",
      "Passport, Laundry & Sandal Bags",
      "Practical Umrah Guide Book",
      "Book of 125 Daily Muslim Prayers",
      "Prayer & Dhikr Pendant",
      "Keychain",
      "Siskopatuh ID Card",
      "Luggage Tag & Sticker",
      "Manasik & Handling",
    ],
  },
  {
    id: "eq-perkap-dasar",
    tier: 3,
    name_id: "Perkap Dasar Jamaah Baru",
    name_en: "Basic Equipment — New Pilgrim",
    price_idr: 750_000,
    upgrade_price_idr: 1_000_000,
    upgrade_note_id: "Upgrade Exclusive Moslem Wear by Fadkhera",
    upgrade_note_en: "Upgrade to Exclusive Moslem Wear by Fadkhera",
    note_id: "Dasar Jamaah Baru",
    note_en: "New Pilgrim Basic",
    accent: "sky",
    items_id: [
      "Exclusive Moslem Wear by ANTUM",
      "Syal Sajadah",
      "Buku Panduan Umrah",
      "Gantungan Doa & Dzikir",
      "Cover Koper",
      "ID Card Siskopatuh",
      "Tag Koper dan Stiker Koper",
      "Manasik dan Handling",
    ],
    items_en: [
      "Exclusive Moslem Wear by ANTUM",
      "Prayer Mat Scarf",
      "Umrah Guide Book",
      "Prayer & Dhikr Pendant",
      "Luggage Cover",
      "Siskopatuh ID Card",
      "Luggage Tag & Sticker",
      "Manasik & Handling",
    ],
  },
  {
    id: "eq-alumni",
    tier: 4,
    name_id: "Perlengkapan Dasar Alumni",
    name_en: "Alumni Basic Equipment",
    price_idr: 500_000,
    note_id: "Dasar Alumni",
    note_en: "Alumni Basic",
    accent: "rose",
    items_id: [
      "Cover koper (untuk koper bagasi maks 24 inch dan bisa dipasangkan di koper sejak dari kediaman masing-masing)",
      "Free sample umrah gift by Batik Travel",
    ],
    items_en: [
      "Luggage cover (fits 24-inch bags, can be attached from home)",
      "Free sample umrah gift by Batik Travel",
    ],
  },
];

export const findEquipmentById = (id) => EQUIPMENT_PACKAGES.find((e) => e.id === id);

export const formatIDR = (n) => `Rp ${new Intl.NumberFormat("id-ID").format(Math.round(n || 0))}`;
